import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useParams, useLocation } from "react-router-dom";
import loadable from "@loadable/component";
import Loading from "../../../components/utils/loader";
import "../../../assets/css/cms/ManageRP.css";
import AddEditFlowList from "./inputResultFlowType/addEditFlowList";
import { useSelector } from "react-redux";
import ManageInput from "./createForm/manageInput";

const MeritList = loadable(() => import("./meritList"), {
  fallback: () => <Loading />,
});
const CustomMean = loadable(() => import("./customMean"), {
  fallback: () => <Loading />,
});
const AppearedStudents = loadable(() => import("./appearedStudents"), {
  fallback: () => <Loading />,
});
const CreateForm = loadable(() => import("./createForm"), {
  fallback: () => <Loading />,
});
const VariationFactor = loadable(() => import("./variationFactor"), {
  fallback: () => <Loading />,
});
const UsageReport = loadable(() => import("./usageReport"), {
  fallback: () => <Loading />,
});
const SessionYear = loadable(() => import("./sessionYear"), {
  fallback: () => <Loading />,
});
const InputResultFlowType = loadable(() => import("./inputResultFlowType"), {
  fallback: () => <Loading />,
});
const PermissionDenied = loadable(() => import("../../cms/common/permissionDenied"), {
  fallback: () => <Loading />,
});

const ACTIONS = {
  ADD_EDIT: "add-edit",
  UPDATE_TABLE: "update-table",
};

const RP_ROUTES = [
  {
    path: "",
    exact: true,
    title: "RP Merit List",
    element: <MeritList />,
    application: "upload_rp_merit_list_cnext_result_predictor",
    action: "Upload RP Merit List",
  },
  {
    path: "custom-mean",
    exact: true,
    title: "RP Custom Mean-SD",
    element: <CustomMean />,
    application: "manage_rp_custom_mean_sd_cnext_result_predictor",
    action: "Manage RP Custom Mean SD",
  },
  {
    path: "appeared-students",
    exact: true,
    title: "RP Appeared Students",
    element: <AppearedStudents />,
    application: "manage_rp_appeared_candidates_cnext_result_predictor",
    action: "Manage RP Appeared Candidates",
  },
  {
    path: "create-form",
    exact: true,
    title: "RP Create Form",
    element: <CreateForm />,
    addEditComponent: <ManageInput/>,
    actions: {
      [ACTIONS.ADD_EDIT]:  <ManageInput/>,
    },
    application: "manage_rp_input_form_cnext_result_predictor",
    action: "Manage RP Input Form",
  },
  {
    path: "variation-factor",
    exact: true,
    title: "RP Variation Factor",
    element: <VariationFactor />,
    application: "manage_rp_variation_factor_cnext_result_predictor",
    action: "Manage RP Variation Factor",
  },
  // {
  //   path: "usage-report",
  //   exact: true,
  //   title: "RP Usage Report",
  //   element: <UsageReport />,
  //   application: "view_rp_usage_cnext_result_predictor",
  //   action: "View RP Usage",
  // },
  {
    path: "session-year",
    exact: true,
    title: "RP Session Year",
    element: <SessionYear />,
    application: "manage_rp_exam_session_cnext_result_predictor",
    action: "Manage RP Exam Session",
  },
  {
    path: "input-result-flow-type",
    exact: true,
    title: "RP Input Result Flow Type",
    element: <InputResultFlowType />,
    addEditComponent: <AddEditFlowList />,
    actions: {
      [ACTIONS.ADD_EDIT]: <AddEditFlowList />,
      application: "add_edit_rp_flow_types_cnext_result_predictor",
      action: "Add Edit RP Flow Types",
    },
    application: "view_rp_flow_types_cnext_result_predictor",
    action: "View RP Flow Types",
  },
];

const ManageRP = () => {
  const location = useLocation();
  const { param, id } = useParams();
  const [activeComponent, setActiveComponent] = useState();
  const { userPermission } = useSelector((state) => {
    return state.userData; // Returning the desired state values
  });

  const isAddEditRoute = location.pathname.includes("add-edit");
  const relatedPath = location.pathname.split("/add-edit")[0];

  // function to find permissions
  const findPermission = (contentType, permissionName) => {
    let authorized = false;
    const userPermissions = userPermission?.data;
    if (userPermissions) {
      authorized = userPermissions.some(permission => {
        return permission.codename === contentType && permission.name === permissionName
      });
    }
    return authorized;
  }

  useEffect(() => {
    // default panel check
    if (window.location.pathname === "/cms/manage-rp/" || window.location.pathname === "/cms/manage-rp") {
      const activeDefaultRoute = RP_ROUTES[0]
      // checking the permission for default panel (Merit List Panel)
      if (activeDefaultRoute?.application && activeDefaultRoute?.action && !findPermission(activeDefaultRoute?.application, activeDefaultRoute?.action)) {
        setActiveComponent(<PermissionDenied />)
      } else {
        setActiveComponent(activeDefaultRoute ? activeDefaultRoute.element : RP_ROUTES[0].element);
      }
    }
    // checking the permission for rather than default panel (rest all panels)
    else if (param) {
      const activeRoute = RP_ROUTES.find((route) => route.path === param);
      setActiveComponent( activeRoute ? activeRoute.element : RP_ROUTES[0].element);
      if (isAddEditRoute) {
        // Find the base route and render its add/edit component
        const baseRoute = RP_ROUTES.find((route) =>
          relatedPath.endsWith(`/cms/manage-rp/${route.path}`)
        );
        // checking the permission for add-edit page of each panels
        if (activeRoute?.actions?.application && activeRoute?.actions?.action && !findPermission(activeRoute?.actions?.application, activeRoute?.actions?.action)) {
          setActiveComponent(<PermissionDenied />)
        } else {
          setActiveComponent(baseRoute?.addEditComponent || RP_ROUTES[0].addEditComponent);
        }
      }
      // checking the permission for each panels of manage rp
      if (activeRoute?.application && activeRoute?.action && !findPermission(activeRoute?.application, activeRoute?.action)) {
        setActiveComponent(<PermissionDenied />)
      }
    }
    else {
      setActiveComponent(RP_ROUTES[0].element);
    }
  }, [param, isAddEditRoute, relatedPath]);


  return (
    <div>
      <div className="">
        <Nav
          className="sub_nav"
          style={{
            paddingLeft: "1rem",
          }}
        >
          {RP_ROUTES.map((route, index) => (
            <Nav.Item
              key={index}
              className={`${relatedPath === `/cms/manage-rp/${route.path}`
                ? "nav_links_active"
                : ""
                }`}
            >
              <Nav.Link
                as={Link}
                to={`/cms/manage-rp/${route.path}`}
                className="text-primary"
                style={{padding:'0.75rem 0.5rem'}}
              >
                {route.title}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>
      <div className="mt-4 main-component">{activeComponent}</div>
    </div>
  );
};

export default ManageRP;